module.exports = __webpack_public_path__ + "static/media/tmc-app.11fd07c6.png";